<template>
  <div class="box" :style="'top:' + boxPosition + '%'">
    <!-- <div
      class="canvas-area"
      v-if="isCanvasShow"
    >

    </div> -->
    <div class="demo-box">
      <div class="app-logo">
        <img :src="appLogo" />
      </div>
      <div class="app-demo">
        <div class="app-left">
          <img :src="appLeftImg" alt="">
        </div>
        <div class="app-right">
          <div class="search-box-title">
            在中日本人10万人をサポートするまるごとアプリ
          </div>
          <div class="search-box">
            <div class="search-input-area">Nanaco 中国</div>
            <div class="search-btn-area">
              <Icon type="ios-search" />
            </div>
          </div>
          <div class="download-btn-box">
            <div class="apple-download">
              <a href="https://apps.apple.com/cn/app/id1329328896">
                <div class="down-icon">
                  <img
                    :src="downloadImage.ios"
                    @mouseenter="isQrcodeShow = 'ios'"
                    @mouseleave="isQrcodeShow = null"
                  />
                </div>
              </a>
              <transition name="qrcode">
                <div class="qrcode-area">
                  <img src="../../images/home/apple-qrcode.png" />
                </div>
              </transition>
            </div>
            <div class="google-play-download">
              <a
                href="https://play.google.com/store/apps/details?id=com.jlkf.zhongying"
              >
                <div
                  class="down-icon"
                  @mouseenter="isQrcodeShow = 'android'"
                  @mouseleave="isQrcodeShow = null"
                >
                  <img :src="downloadImage.android" />
                </div>
              </a>
              <transition name="qrcode">
                <div class="qrcode-area">
                  <img src="../../images/home/google-qrcode.png" />
                </div>
              </transition>
            </div>
            <div class="google-play-download">
              <a
                href="https://data.nanaco.com.cn/nanaco-data/apk/nanacoLatest.apk"
              >
                <div class="down-icon">
                  <img :src="downloadImage.apk" />
                </div>
                 <transition name="qrcode">
                <div class="qrcode-area">
                  <img :src="downloadImage_android" />
                </div>
              </transition>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg">
      <img :src="appdownloadbg" alt="">
    </div>
  </div>
</template>
<script>
// import RENDERER from '../js/RENDERER'
import { appLogo, downloadImage,appLeftImg,appdownloadbg,downloadImage_android } from "../../images/home/index";
export default {
  data() {
    return {
      boxPosition: "100",
      isCanvasShow: false,
      appLogo,
      appLeftImg,
      downloadImage,
      appdownloadbg,
      downloadImage_android,
      isQrcodeShow: null,
    };
  },
  methods: {
    init() {
      // this.isCanvasShow = true
      // this.$nextTick(() => {
      //   RENDERER.init(document.getElementsByClassName('canvas-area')[0])
      // })
    },
    up() {
      this.boxPosition = "-100";
      // RENDERER.stop()
      // this.isCanvasShow = false
    },
    nomal() {
      this.boxPosition = "0";
      // this.init()
    },
    down() {
      this.boxPosition = "100";
      // RENDERER.stop()
      // this.isCanvasShow = false
    },
  },
};
</script>
<style scoped>
.canvas-area {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
}
.demo-box {
  position: absolute;
  /* background: rgba(0, 0, 0, 0.5); */
  /* background-color: rgba(238, 242, 255, 1); */
  /* background-image: url('../../images/home/app-down-bg.png'); */
  background-size: 100%;
  background-position: bottom;
  background-repeat: no-repeat;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-top: 0.6rem;
}
.app-logo {
  /* margin: 0 auto;
  margin-top: 5%;
  width: 3rem;
  height: auto;
  position: absolute;
  top: 0.6rem; */
  text-align: center;
  width: 2.5rem;
  height: 2rem;
  position: absolute;
  top: 0.6rem;
  left: 50%;
  margin-left: -1.5rem;
  z-index: 99;
}
.app-logo img {
  display: block;
  width: 100%;
  
  border-radius: 0.1rem;
}
.app-demo{
  width: 100%;
  /* display: flex;
  justify-content: space-around; */
}
.app-left{
  width: 7rem;
  height: 6rem;
  margin-top: -3rem;
  position: absolute;
  top: 50%;
  left: 0;
}
.app-left img{
  width: 100%;
  height: auto;
}
.search-box-title {
  width: 12rem;
  margin: 0 auto;
  text-align: center;
  font-size: 0.25rem;
  font-weight: bold;

  color: rgba(7, 7, 7, 1);
  margin-top: 0.28rem;
  margin-bottom: 0.3rem;
  letter-spacing: 0.02rem;
}
.app-right{
  margin-right: 0.9rem;
  margin-top: 1rem;
  height: 6rem;
  position: absolute;
  top: 50%;
  margin-top: -2rem ;
  right: 1rem;
}
.search-box {
  height: 0.6rem;
  width: 6rem;
  margin: 0 auto;
  border-radius: 1rem;
  overflow: hidden;
  display: flex;
  box-shadow: 0px 0px 41px 0px rgba(129, 129, 129, 0.18);
  margin-bottom: 0.6rem;
}
.search-input-area {
  width: 5rem;
  background: #fff;
  color: rgba(7, 7, 7, 1);
  box-sizing: border-box;
  padding-left: 1.2rem;
  text-align: center;
  line-height: 0.6rem;
  font-size: 0.2rem;
  font-weight: bold;
}
.search-btn-area {
  background-color: rgba(51, 51, 51, 1);
  text-align: center;
  color: rgba(255, 255, 255, 1);
  line-height: 0.6rem;
  font-size: 0.3rem;
  width: 1.2rem;
  text-indent: -0.05rem;
}
.download-btn-box {
  width: 5.5rem;
  height: 0.5rem;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  box-sizing: border-box;
  padding: 0 0.2rem;
}
.down-icon img {
  height: 0.5rem;
  width: auto;
  display: block;
}
.qrcode-area {
  width: 100%;
  height: 1.5rem;
  border-radius: 0.1rem;
  margin: 0 auto;
  /* background: rgba(0, 0, 0, 1); */
  margin-top: 0.1rem;
  position: relative;
  overflow: hidden;
}
.qrcode-area img {
  display: block;
  height: 1.3rem;
  width: 1.3rem;
  margin: 0 auto;
  margin-top: 0.1rem;
  background: #fff;
}
.qrcode-enter-active,
.qrcode-leave-active {
  transition: all 0.5s;
}
.qrcode-enter, .qrcode-leave-to /* .fade-leave-active below version 2.1.8 */ {
  height: 0;
  margin-top: 0.1rem;
}
.bg{
  width: 100vw;
  height: 100vh;
  position: absolute;
  z-index: -1;
}
.bg img{
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/home/modules/app-download.vue